import { traceCoreComponents } from '../helpers/utils';
import userService from '../services/userServices';
import { ALERT_TYPES } from '../helpers/const';
import moment from 'moment-timezone';

export const getEnterprisePermissionsRequest = () => ({ type: 'GET_ENTERPRISE_PERMISSIONS_REQUEST' });
export const getEnterprisePermissionsSuccess = (permissions) => ({
    type: 'GET_ENTERPRISE_PERMISSIONS_SUCCESS',
    permissions
});
export const getEnterprisePermissionsApiError = (message, form) => ({
    type: 'GET_ENTERPRISE_PERMISSIONS_API_ERROR',
    message,
    form
});

export const getEnterpriseRolesRequest = () => ({ type: 'GET_ENTERPRISE_ROLES_REQUEST' });
export const getEnterpriseRolesSuccess = (enterpriseRoles) => ({
    type: 'GET_ENTERPRISE_ROLES_SUCCESS',
    enterpriseRoles
});
export const getEnterpriseRolesApiError = (message, form) => ({
    type: 'GET_ENTERPRISE_ROLES_API_ERROR',
    message,
    form
});

export const viewUsersRequest = (filters) => ({ type: 'VIEW_USERS_REQUEST', filters });
export const viewUsersSuccess = (data) => ({ type: 'VIEW_USERS_SUCCESS', data });
export const viewUsersApiError = (message, form) => ({ type: 'VIEW_USERS_API_ERROR', message, form });

export const usersCountRequest = (filters) => ({ type: 'USERS_COUNT_REQUEST', filters });
export const usersCountSuccess = (data) => ({ type: 'USERS_COUNT_SUCCESS', data });
export const usersCountApiError = (message, form) => ({ type: 'USERS_COUNT_API_ERROR', message, form });

export const userOptionsRequest = (filters) => ({ type: 'USER_OPTIONS_REQUEST', filters });
export const userOptionsSuccess = (data) => ({ type: 'USER_OPTIONS_SUCCESS', data });
export const userOptionsApiError = (message, form) => ({ type: 'USER_OPTIONS_API_ERROR', message, form });

export const deleteUserRequest = (filters) => ({ type: 'DELETE_USER_REQUEST', filters });
export const deleteUserSuccess = (data) => ({ type: 'DELETE_USER_SUCCESS', data });
export const deleteUserApiError = (message, form) => ({ type: 'DELTE_USER_API_ERROR', message, form });

export const updateUsersRequest = (filters) => ({ type: 'UPDATE_USERS_REQUEST', filters });
export const updateUsersSuccess = (data) => ({ type: 'UPDATE_USERS_SUCCESS', data });
export const updateUsersApiError = (message, form) => ({ type: 'UPDATE_USERS_API_ERROR', message, form });

export const removeUsersRequest = (filters) => ({ type: 'REMOVE_USERS_REQUEST', filters });
export const removeUsersSuccess = (data) => ({ type: 'REMOVE_USERS_SUCCESS', data });
export const removeUsersApiError = (message, form) => ({ type: 'REMOVE_USERS_API_ERROR', message, form });

export const submitAddRoleRequest = (form) => ({ type: 'SUBMIT_ADD_ROLE_REQUEST', form });
export const submitAddRoleSuccess = (profiles) => ({ type: 'SUBMIT_ADD_ROLE_SUCCESS', profiles });
export const submitAddRoleApiError = (message, form) => ({ type: 'SUBMIT_ADD_ROLE_API_ERROR', message, form });

export const viewRolesRequest = (filters) => ({ type: 'VIEW_ROLES_REQUEST', filters });
export const viewRolesSuccess = (data) => ({ type: 'VIEW_ROLES_SUCCESS', data });
export const viewRolesApiError = (message, form) => ({ type: 'VIEW_ROLES_API_ERROR', message, form });

export const removeRolesRequest = (filters) => ({ type: 'REMOVE_ROLES_REQUEST', filters });
export const removeRolesSuccess = (data) => ({ type: 'REMOVE_ROLES_SUCCESS', data });
export const removeRolesApiError = (message, form) => ({ type: 'REMOVE_ROLES_API_ERROR', message, form });

export const initModifyRolesRequest = (id) => ({ type: 'INIT_MODIFY_ROLES_REQUEST', id });
export const initModifyRolesSuccess = (data) => ({ type: 'INIT_MODIFY_ROLES_SUCCESS', data });
export const initModifyRolesApiError = (message, form) => ({ type: 'INIT_MODIFY_ROLES_API_ERROR', message, form });

export const viewPreferenceRequest = (filter) => ({ type: 'VIEW_USER_PREFERENCE', filter });
export const viewPreferenceRequestSuccess = (status, data) => ({ type: 'VIEW_USER_PREFERENCE_SUCCESS', status, data });
export const viewPreferenceAPIError = (message, form) => ({ type: 'VIEW_USER_PREFERENCE_API_ERROR', message, form });
export const savePreferenceRequest = (filter) => ({ type: 'SAVE_USER_PREFERENCE', filter });
export const savePreferenceRequestSuccess = (status, data) => ({ type: 'SAVE_USER_PREFERENCE_SUCCESS', status, data });
export const savePreferenceAPIError = (message, form) => ({ type: 'SAVE_USER_PREFERENCE_API_ERROR', message, form });

export const viewCustomDeviceRequest = (filter) => ({ type: 'VIEW_CUSTOM_DEVICE_REQUEST', filter });
export const viewCustomDeviceRequestSuccess = (status, data) => ({ type: 'VIEW_CUSTOM_DEVICE_REQUEST_SUCCESS', status, data });
export const viewCustomDeviceAPIError = (message, form) => ({ type: 'VIEW_CUSTOM_DEVICE_API_ERROR', message, form });
export const saveCustomDeviceRequest = (filter) => ({ type: 'SAVE_CUSTOM_DEVICE', filter });
export const saveCustomDeviceRequestSuccess = (status, data) => ({ type: 'SAVE_CUSTOM_DEVICE_SUCCESS', status, data });
export const saveCustomDeviceAPIError = (message, form) => ({ type: 'SAVE_CUSTOM_DEVICE_API_ERROR', message, form });

export const viewUserNotifications = () => ({ type: 'VIEW_NOTIFICATIONS', data: {} });
export const viewUserNotificationsSuccess = (status, data) => ({ type: 'VIEW_NOTIFICATIONS_SUCCESS', status, data });
export const viewUserNotificationsAPIError = (message, form) => ({ type: 'VIEW_NOTIFICATIONS_API_ERROR', message, form });

export const deleteUserNotification = (id) => ({ type: 'DELETE_NOTIFICATION', data: { deleteUserNotification } });
export const deleteUserNotificationSuccess = (status, data) => ({ type: 'DELETE_NOTIFICATION_SUCCESS', status, data });
export const deleteUserNotificationAPIError = (message, form) => ({ type: 'DELETE_NOTIFICATION_API_ERROR', message, form });

export const prepopulateUsersRequest = () => ({ type: 'PREPOPULATE_USERS_PREFERENCE', data: {} });
export const prepopulateUsersSuccess = (status, data) => ({ type: 'PREPOPULATE_USERS_SUCCESS', status, data });
export const prepopulateUsersAPIError = (message, form) => ({ type: 'PREPOPULATE_USERS_API_ERROR', message, form });

export const getEnterprisePermissions =
    (id = false) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(id ? initModifyRolesRequest(id) : getEnterprisePermissionsRequest());
            userService.getEnterprisePermissions(id).then(
                (response) => {
                    const { data = {} } = response;
                    const { options = {}, defaultRole = false, role } = data;
                    const { permissions = [] } = options;

                    dispatch(id ? initModifyRolesSuccess(data) : getEnterprisePermissionsSuccess(permissions));

                    resolve({ permissions, role, defaultRole });
                },
                (error) => {
                    const { message, form = {} } = error.data;
                    dispatch(getEnterprisePermissionsApiError(message, form));
                    return reject({ message, form });
                }
            );
        });

export const getEnterpriseRoles = () => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(getEnterpriseRolesRequest());

        userService.getEnterpriseRoles().then(
            (response) => {
                const { data = {} } = response;
                const enterpriseRoles = Object.keys(data).map((key) => ({ key, text: data[key], value: key }));

                dispatch(getEnterpriseRolesSuccess(enterpriseRoles));
                resolve(enterpriseRoles);
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(getEnterpriseRolesApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const submitAddRole = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(submitAddRoleRequest(json));

        userService.submitAddRole(json).then(
            (response) => {
                const { data } = response;
                dispatch(submitAddRoleSuccess(data));
                resolve(data);
            },
            (error) => {
                const { message, form = [] } = error.data;

                dispatch(submitAddRoleApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const initAddUserRequest = () => ({ type: 'INIT_ADD_USER_REQUEST' });
export const initAddUserSuccess = (options) => ({ type: 'INIT_ADD_USER_SUCCESS', options });
export const initAddUserApiError = (message, form) => ({ type: 'INIT_ADD_USER_API_ERROR', message, form });

export const initModifyUserRequest = (id) => ({ type: 'INIT_MODIFY_USER_REQUEST', id });
export const initModifyUserSuccess = (options, user) => ({ type: 'INIT_MODIFY_USER_SUCCESS', options, user });
export const initModifyUserApiError = (message, form) => ({ type: 'INIT_MODIFY_USER_API_ERROR', message, form });
// UserIds
export const initAddUserIdsRequest = () => ({ type: 'INIT_ADD_USER_IDS_REQUEST' });
export const initAddUserIdsSuccess = (options) => ({ type: 'INIT_ADD_USER_IDS_SUCCESS', options });
export const initAddUserIdsApiError = (message, form) => ({ type: 'INIT_ADD_USER_IDS_API_ERROR', message, form });

export const initModifyUserIdsRequest = (id) => ({ type: 'INIT_MODIFY_USER_IDS_REQUEST', id });
export const initModifyUserIdsSuccess = (options, user) => ({ type: 'INIT_MODIFY_USER_IDS_SUCCESS', options, user });
export const initModifyUserIdsApiError = (message, form) => ({ type: 'INIT_MODIFY_USER_IDS_API_ERROR', message, form });

export const submitAddUserRequest = (form) => ({ type: 'SUBMIT_ADD_USER_REQUEST', form });
export const submitAddUserSuccess = (profiles) => ({ type: 'SUBMIT_ADD_USER_SUCCESS', profiles });
export const submitAddUserApiError = (message, form) => ({ type: 'SUBMIT_ADD_USER_API_ERROR', message, form });

export const submitModifyUserRequest = (form) => ({ type: 'SUBMIT_MODIFY_USER_REQUEST', form });
export const submitModifyUserSuccess = (profiles) => ({ type: 'SUBMIT_MODIFY_USER_SUCCESS', profiles });
export const submitModifyUserApiError = (message, form) => ({ type: 'SUBMIT_MODIFY_USER_API_ERROR', message, form });

export const initManageUser =
    (userId, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(userId ? initModifyUserRequest(userId) : initAddUserRequest());

            userService.initManageUser(userId, config).then(
                (response) => {
                    const { options = {}, user } = response.data;
                    dispatch(userId ? initModifyUserSuccess(options, user) : initAddUserSuccess(options));

                    const { rolesMap = {}, userMap = {} } = options;
                    const enterpriseRoles = Object.keys(rolesMap).map((key) => ({ key, text: rolesMap[key], value: rolesMap[key] }));
                    //const userIds = Object.keys(userIds).map((key) => ({ key, text: userMap[key], value: key }));

                    resolve({ enterpriseRoles, user });
                },
                (error) => {
                    const { message, form = [] } = error.data;
                    dispatch(userId ? initModifyUserApiError(message, form) : initAddUserApiError(message, form));
                    return reject({ message, form });
                }
            );
        });
// UserIds
export const initUserIdsList = (userId) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(userId ? initModifyUserIdsRequest(userId) : initAddUserIdsRequest());

        userService.initManageIdsUser(userId).then(
            (response) => {
                const { userIdList = [], firstName, lastName } = response.data;

                dispatch(userId ? initModifyUserIdsSuccess(userIdList, firstName, lastName) : initAddUserIdsSuccess(userIdList, firstName, lastName));
                // const userIdListMap = Object.keys(userIdList).map((key) => ({ key: userIdList[key], text: userIdList[key], value: userIdList[key] }));
                let userIdListMap = userIdList?.length > 0 ? userIdList.map((el) => ({ key: el, text: el, value: el })) : [];
                resolve({ userIdListMap, firstName, lastName });
            },
            (error) => {
                const { message, form = [] } = error.data;
                dispatch(userId ? initModifyUserIdsApiError(message, form) : initAddUserIdsApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const submitManageUser =
    (json, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(submitAddUserRequest(json));

            userService.submitManageUser(json, config).then(
                (response) => {
                    const { data } = response;
                    dispatch(submitAddUserSuccess(data));
                    resolve(data);
                },
                (error) => {
                    const { message, form = [] } = error.data;

                    dispatch(submitAddUserApiError(message, form));
                    return reject({ message, form });
                }
            );
        });

export const initModifyUser = (id) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(initModifyUserRequest(id));

        userService.initModifyUser(id).then(
            (response) => {
                const { data } = response;
                dispatch(initModifyUserSuccess(data));
                resolve(data);
            },
            (error) => {
                const { message, form = [] } = error.data;

                dispatch(initModifyUserApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const submitModifyUser = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(submitModifyUserRequest(json));

        userService.submitModifyUser(json).then(
            (response) => {
                const { data } = response;
                dispatch(submitModifyUserSuccess(data));
                resolve(data);
            },
            (error) => {
                const { message, form = [] } = error.data;

                dispatch(submitModifyUserApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const viewUsers =
    (filters, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(viewUsersRequest(filters));

            userService.viewUsers(filters, config).then(
                (response) => {
                    const { data } = response;
                    dispatch(viewUsersSuccess(data));
                    resolve(data);
                },
                (error) => {
                    const { message, form = {} } = error.data;
                    dispatch(viewUsersApiError(message, form));
                    return reject({ message, form });
                }
            );
        });
export const usersCount =
    (filters, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(usersCountRequest(filters));

            userService.usersCount(filters, config).then(
                (response) => {
                    const { data } = response;

                    dispatch(usersCountSuccess(data || {}));
                    resolve(data || {});
                },
                (error) => {
                    const { message, form = [] } = error.data;
                    dispatch(usersCountApiError(message, form));
                    return reject({ message, form });
                }
            );
        });
export const userOptions =
    (filters, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(userOptionsRequest(filters));

            userService.userOptions(filters, config).then(
                (response) => {
                    const { data } = response;

                    dispatch(userOptionsSuccess(data || {}));
                    resolve(data || {});
                },
                (error) => {
                    const { message, form = [] } = error.data;
                    dispatch(userOptionsApiError(message, form));
                    return reject({ message, form });
                }
            );
        });
export const updateUsers =
    (filters, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(updateUsersRequest(filters));

            userService.updateUsers(filters, config).then(
                (response) => {
                    const { data } = response;
                    dispatch(updateUsersSuccess(data));
                    resolve(data);
                },
                (error) => {
                    const { message, form = [] } = error.data;
                    dispatch(updateUsersApiError(message, form));
                    return reject({ message, form });
                }
            );
        });

export const deleteUser =
    (filters, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(deleteUserRequest(filters));

            userService.deleteUser(filters, config).then(
                (response) => {
                    const { data } = response;
                    dispatch(deleteUserSuccess(data));
                    resolve(data);
                },
                (error) => {
                    const { message, form = [] } = error.data;
                    dispatch(deleteUserApiError(message, form));
                    return reject({ message, form });
                }
            );
        });

export const removeUsers =
    (selected, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(removeUsersRequest(selected));

            userService.removeUsers(selected, config).then(
                (response) => {
                    const { data } = response;
                    dispatch(removeUsersSuccess(data));
                    resolve(data);
                },
                (error) => {
                    const { message, form = {} } = error.data;
                    dispatch(removeUsersApiError(message, form));
                    return reject({ message, form });
                }
            );
        });

export const viewRoles =
    (filters, config = {}) =>
    (dispatch) =>
        new Promise((resolve, reject) => {
            dispatch(viewRolesRequest(filters));

            userService.viewRoles(filters, config).then(
                (response) => {
                    const { data } = response;
                    dispatch(viewRolesSuccess(data));
                    resolve(data);
                },
                (error) => {
                    const { message, form = {} } = error.data;
                    dispatch(viewRolesApiError(message, form));
                    return reject({ message, form });
                }
            );
        });

export const removeRoles = (selected) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(removeRolesRequest(selected));

        userService.removeRoles(selected).then(
            (response) => {
                const { data } = response;
                dispatch(removeRolesSuccess(data));
                resolve(data);
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(removeRolesApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const getUserPreference = () => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(viewPreferenceRequest());

        userService.getUserPreference().then(
            (response) => {
                const { status, data } = response;
                dispatch(viewPreferenceRequestSuccess(status, data));
                resolve({ userPreference: data?.userPreference || '{}' });
            },
            (error) => {
                dispatch(viewPreferenceAPIError('Get user preference api is failed' + error.data, {}));
                return resolve({ userPreference: '{}' });
            }
        );
    });

export const savePreference = (updatePreference) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(savePreferenceRequest(updatePreference));
        userService.savePreference(updatePreference).then(
            (response) => {
                const { status } = response;
                dispatch(savePreferenceRequestSuccess(status, updatePreference));
                resolve({ status });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(savePreferenceAPIError(message, form));
                return reject({ message, form });
            }
        );
    });

export const getCustomDeviceNames = () => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(viewCustomDeviceRequest());

        userService.getCustomDeviceNames().then(
            (response) => {
                const { status, data } = response;
                dispatch(viewCustomDeviceRequestSuccess(status, data));
                resolve(data?.customDeviceNames || []);
            },
            (error) => {
                dispatch(viewCustomDeviceAPIError('Get custom device names api is failed' + error.data, {}));
                return resolve([]);
            }
        );
    });

export const saveCustomDeviceName = (customDevice) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(saveCustomDeviceRequest(customDevice));
        userService.saveCustomDeviceName(customDevice).then(
            (response) => {
                const { status } = response;
                dispatch(saveCustomDeviceRequestSuccess(status, customDevice));
                resolve({ status });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(saveCustomDeviceAPIError(message, form));
                return reject({ message, form });
            }
        );
    });

export const getUserNotifications = () => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(viewUserNotifications());
        userService.viewUserNotifications().then(
            (response) => {
                const { status, data } = response;

                // Combine notifications and future notifications
                if (data.futureNotifications) {
                    data.notifications = [...data.futureNotifications, ...data.notifications];
                }

                data.notifications = data.notifications.sort((a, b) => {
                    const startDateComparison = b.startDate?.localeCompare(a?.startDate);
                    if (startDateComparison !== 0) return startDateComparison;
                    return b.endDate?.localeCompare(a?.endDate);
                });

                dispatch(viewUserNotificationsSuccess(status, {}));
                resolve({ data });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(viewUserNotificationsAPIError(message, form));
                return reject({ message, form });
            }
        );
    });

export const removeUserNotification = (id) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(deleteUserNotification(id));
        userService.deleteUserNotification(id).then(
            (response) => {
                const { status } = response;
                dispatch(deleteUserNotificationSuccess(status, { id }));
                resolve({ status });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(deleteUserApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const prepopulateUsers = () => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(prepopulateUsersRequest());

        userService.prepopulateUsers().then(
            (response) => {
                const { status, data } = response;
                dispatch(prepopulateUsersSuccess(status, data));
                resolve({ status, data });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(prepopulateUsersAPIError(message, form));
                return reject({ message, form });
            }
        );
    });
